import React from 'react';

const VARIANT_CLASS = {
  primary: 'ui-btn--primary',
  secondary: 'ui-btn--secondary',
  success: 'ui-btn--success',
  danger: 'ui-btn--danger',
  warning: 'ui-btn--warning',
  outline: 'ui-btn--outline',
  ghost: 'ui-btn--ghost',
};

/**
 * @param {Object} props
 * @param {'primary'|'secondary'|'success'|'danger'|'warning'|'outline'|'ghost'} [props.variant='primary']
 * @param {'sm'|'md'|'lg'} [props.size='md']
 * @param {React.ReactNode} [props.icon] - Icono al inicio (alias de startIcon)
 * @param {React.ReactNode} [props.startIcon]
 * @param {React.ReactNode} [props.endIcon]
 */
const BaseButton = ({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  loading = false,
  disabled = false,
  fullWidth = false,
  icon,
  startIcon,
  endIcon,
  iconPosition = 'start',
  className = '',
  onClick,
  ...rest
}) => {
  const isDisabled = disabled || loading;
  const leadingIcon = startIcon ?? (iconPosition === 'start' ? icon : null);
  const trailingIcon = endIcon ?? (iconPosition === 'end' ? icon : null);

  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={onClick}
      className={[
        'ui-btn',
        VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
        size === 'sm' ? 'ui-btn--sm' : size === 'lg' ? 'ui-btn--lg' : 'ui-btn--md',
        fullWidth ? 'ui-btn--full' : '',
        loading ? 'ui-btn--loading' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      <span className="ui-btn__content">
        {loading && <span className="ui-btn__spinner" aria-hidden />}
        {!loading && leadingIcon && (
          <span className="ui-btn__icon ui-btn__icon--start" aria-hidden>
            {leadingIcon}
          </span>
        )}
        {children != null && children !== '' && (
          <span className="ui-btn__label">{children}</span>
        )}
        {!loading && trailingIcon && (
          <span className="ui-btn__icon ui-btn__icon--end" aria-hidden>
            {trailingIcon}
          </span>
        )}
      </span>
    </button>
  );
};

export default BaseButton;
